var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    width: 14.519,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c2f87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.09 24.75a.778.778 0 1 0 .778.778.778.778 0 0 0 -.778-.778z",
    transform: "translate(-9.831 -15.379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.875 12.375h1.037v4.666h-1.037z",
    transform: "translate(-10.135 -8.706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.247 16.245h-13.48a.518.518 0 0 1 -.461-.757l6.74-12.961a.518.518 0 0 1 .923 0l6.74 12.961a.518.518 0 0 1 -.461.757zm-12.625-1.036h11.769l-5.884-11.318z",
    transform: "translate(-2.248 -2.245)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlt);
export default __webpack_public_path__ + "static/media/warning-alt.23eeccb2c17b4d7ae4a63907bf27d0c5.svg";
export { ForwardRef as ReactComponent };